import { useAuth } from "../../../../context";
import { useMutation } from "react-query";
import { UseOfSoldProducts } from "../../../../api";

export function useImportUseOfSoldProducts(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(UseOfSoldProducts.importUseOfSoldProducts, { questionnaireId, data }), config);
}

export function useUpdateUseOfSoldProducts(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, id, data }) =>
    callApi(UseOfSoldProducts.updateUseOfSoldProducts, { questionnaireId, data }), config);
}

export function useDownloadUseOfSoldProductsTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(UseOfSoldProducts.getUseOfSoldProductsTemplate), config);
}